import { render, staticRenderFns } from "./VVideoButton.vue?vue&type=template&id=9bbbab52&"
import script from "./VVideoButton.vue?vue&type=script&lang=ts&"
export * from "./VVideoButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports